import { registerQuery, useQuery } from 'data-fetching-client';
import userInfoHubHttp from 'hub-http/userInfo';
import { gate, v2gate } from 'hub-http/gates';
const hubSpotRTEMigrationGate = v2gate('MO:CollaborationSidebar:HubSpotRTEMigration');
const realtimeCommentingGate = gate('MarketingPlatform::RealtimeCommenting');
const breezeAssistantRebrandGate = gate('BreezeAssistant:Rebrand:2025');
const buildGatesForUser = gates => {
  const gatesForUser = {
    hubSpotRTEMigration: false,
    realtimeCommenting: false,
    breezeAssistantRebrand: false
  };
  let gatesToCheck = Object.keys(gatesForUser).length;
  for (const gateToCheck of gates) {
    if (gateToCheck === hubSpotRTEMigrationGate) {
      gatesForUser.hubSpotRTEMigration = true;
      gatesToCheck = gatesToCheck - 1;
    }
    if (gateToCheck === realtimeCommentingGate) {
      gatesForUser.realtimeCommenting = true;
      gatesToCheck = gatesToCheck - 1;
    }
    if (gateToCheck === breezeAssistantRebrandGate) {
      gatesForUser.breezeAssistantRebrand = true;
      gatesToCheck = gatesToCheck - 1;
    }
    if (gatesToCheck === 0) {
      break;
    }
  }
  return gatesForUser;
};
const SCOPES_FOR_SUPPORTED_HUBS = {
  MARKETING_HUB: 'commenting-access-marketing-hub',
  SERVICE_HUB: 'commenting-access-service-hub',
  CMS_HUB: 'commenting-access-cms-hub',
  OPS_HUB: 'commenting-access-ops-hub',
  SALES_HUB: 'commenting-access-sales-hub'
};
const buildScopesForUser = scopes => {
  const scopesForUser = {
    'ads-read': false,
    'blog-write': false,
    'calendar-access': false,
    'campaigns-access': false,
    'campaigns-write': false,
    'commenting-access-cms-hub': false,
    'commenting-access-marketing-hub': false,
    'commenting-access-ops-hub': false,
    'commenting-access-sales-hub': false,
    'commenting-access-service-hub': false,
    'email-write': false,
    'landingpages-write': false,
    'marketing-tasks-write': false,
    'pages-write': false,
    'teams-content-partitioning': false
  };
  let scopesToCheck = Object.keys(scopesForUser).length;
  const isScopeCollaborationSidebarScope = scope => {
    return scope in scopesForUser;
  };
  for (const scope of scopes) {
    if (isScopeCollaborationSidebarScope(scope)) {
      scopesForUser[scope] = true;
      scopesToCheck = scopesToCheck - 1;
    }
    if (scopesToCheck === 0) {
      break;
    }
  }
  return scopesForUser;
};
const USER_INFO_QUERY = registerQuery({
  args: [],
  fieldName: 'collaborationSidebarUserInfo',
  fetcher: async () => {
    const userInfoResponse = await userInfoHubHttp();
    return Object.assign({}, userInfoResponse, {
      gatesForUser: buildGatesForUser(userInfoResponse.gates || []),
      scopesForUser: buildScopesForUser(userInfoResponse.user.scopes)
    });
  }
});
export const useUserInfo = () => {
  'use memo';

  const {
    data,
    loading: userInfoLoading,
    error: userInfoError
  } = useQuery(USER_INFO_QUERY);
  const hasGate = gateToCheck => {
    var _data$collaborationSi;
    return !!(data !== null && data !== void 0 && (_data$collaborationSi = data.collaborationSidebarUserInfo) !== null && _data$collaborationSi !== void 0 && _data$collaborationSi.gatesForUser[gateToCheck]);
  };
  const hasScope = scopeToCheck => {
    var _data$collaborationSi2;
    return !!(data !== null && data !== void 0 && (_data$collaborationSi2 = data.collaborationSidebarUserInfo) !== null && _data$collaborationSi2 !== void 0 && _data$collaborationSi2.scopesForUser[scopeToCheck]);
  };
  const hasScopeForHub = hub => {
    return hasScope(SCOPES_FOR_SUPPORTED_HUBS[hub]);
  };
  return {
    userInfo: data === null || data === void 0 ? void 0 : data.collaborationSidebarUserInfo,
    userInfoLoading,
    userInfoError,
    hasGate,
    hasScope,
    hasScopeForHub
  };
};